module.exports = __webpack_public_path__ + "img/sio.0f8774bc.png";